import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { Select } from '@components/core-ui/form-elements/Select';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { isTranscriptUnlockType } from '@helpers/isTranscriptUnlockType';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { SubscriptionsService } from 'app/API';
import { notifyApiCallError } from 'app/http/notifyApiCallError';
import { useState } from 'react';
import { Wrapper } from './styles/Wrapper';
import { TProps } from './types/TProps';

export const EditLicenseTranscriptUnlockTypeModal = ({
  baId,
  licenseId,
  initialValue,
  onCancel,
  onSuccess,
}: TProps) => {
  const { call } = useAPI();
  const [value, setValue] = useState(initialValue);

  const values = [
    { label: 'ASOne Enhanced', value: 'ASONE_ENHANCED' },
    { label: 'Session Text', value: 'SESSION_TEXT' },
    { label: 'Choose', value: 'CHOOSE' },
  ];

  const updateMutation = useMutation({
    mutationFn: () =>
      call(() =>
        SubscriptionsService.updateLicenseTranscriptUnlockType({
          baId,
          licenseId,
          requestBody: { transcriptUnlockType: value },
        }),
      ),
    onSuccess: () => {
      onSuccess();
      onCancel();
    },
    onError: notifyApiCallError,
  });

  const isSubmitting = updateMutation.isPending;

  return (
    <Wrapper>
      <ModalWrapper width="487px" overflow="visible">
        {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
        <ModalTitle>Update Transcript Unlock Type</ModalTitle>

        <Select
          name="value"
          label="Transcript Unlock Type"
          className="form-autocomplete"
          value={value}
          onChange={(_, nextValue) => {
            if (isTranscriptUnlockType(nextValue)) {
              setValue(nextValue);
            }
          }}
          options={values}
          required={false}
        />

        <div className="buttonGroup">
          <OutlinedButton onClick={onCancel}>Cancel</OutlinedButton>
          <Button onClick={() => updateMutation.mutate()} disabled={isSubmitting}>
            Update
          </Button>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};
